<style lang="scss">
    $teal: #46B795;
    $lightTeal: #A1DBCA;
    $taBorderRadius: 8px;

    .provider-tools-spotlight.arrow-collapse.dropdown{
        background-color: transparent;
        border-radius: $taBorderRadius;
        padding: 1rem 2rem;
        border: solid 2px $lightTeal;
        margin-top: 1.75rem;
        counter-reset: provider-tools-counter;

        & > .trigger {
            color: $teal;
            // & > div {

                & > .arrow:before {
                    color: $teal;
                }

                & > .trigger-label{
                    vertical-align: middle;
                    line-height: 36px;
                    float: none;
                    color: $teal;
                    // font-weight: normal;

                    & > .provider-tools-icon {
                        position: relative;
                        top: 7px;
                        display: inline-block;
                        width: 46px;
                        height: 36px;
                        margin-right: 1rem;

                        background: url(~public@/images/ta-resources/seafoam_lightbulb.png) 0 0 no-repeat;
                    }
                }
            // }
        }

        & .collapsed-content {
            & h4, h5 {
                color: $teal !important;
            }

            ol {
                list-style: none;
            }
            ol > li {
                counter-increment: provider-tools-counter;
            }
            ol > li::before {
                content: counter(provider-tools-counter)'. ' ;
                font-weight: 600;
                color: $teal;
            }
        }
    }
</style>

<template>
    <arrow-collapse :visible="visible" :accordion="accordion" class="provider-tools-spotlight w-100" :show-line="false" :variant="null">
        <template #trigger-label>
            <span class="provider-tools-icon"></span>
            Provider Tools Spotlight
        </template>
        <template #collapsed-content>
            <slot></slot>
        </template>
    </arrow-collapse>
</template>

<script>
    import ArrowCollapse from '../ArrowCollapse.vue'

    export default {
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            accordion: {
                type: String,
                default: null
            }            
        },
        components: {
            ArrowCollapse
        },
        data() {
            return {}
        },
        methods: {}
    
}
</script>